<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/')"
        >首页</a-breadcrumb-item
      >
      <a-breadcrumb-item href="" @click.native="() => $router.back()"
        >上一页</a-breadcrumb-item
      >
      <a-breadcrumb-item>体检报告</a-breadcrumb-item>
    </a-breadcrumb>

    <div class="header">
      <a-tabs v-model="actived" @change="tabChange">
        <a-tab-pane :key="item.key" :tab="item.name" v-for="item in tabs">
        </a-tab-pane>
      </a-tabs>
    </div>

    <div class="range-picker">
      选择日期: <a-range-picker @change="onChange" />
    </div>

    <div class="tab-content">
      <div class="scroll">
        <div class="list">
          <div class="loading-x" v-if="loading">
          <a-spin tip="加载中..." > </a-spin>
          </div>

          <a-empty v-if="!loading && list.length == 0" />


          <a-card
            v-for="(item, index) in list"
            :key="index"
            :title="'编号：' + item.physicalExamNo"
            style="margin-bottom: 10px"
          >
            <a
              slot="extra"
              class="btn"
              v-if="actived != 3"
              @click="viewResult(item)"
              >体检结论</a
            >
            <a slot="extra" class="btn" @click="onViewReport(item)">查看报告</a>
            <a
              slot="extra"
              class="btn"
              v-if="actived != 3"
              @click="onDown(item)"
              >下载报告</a
            >

            <p>姓名：{{ item.name }}</p>
            <p>时间：{{ item.physicalExamDate }}</p>
          </a-card>
        </div>
      </div>
    </div>
    <!--体检结论-->
    <a-modal title="体检结论" :visible="visible" @ok="onOK" @cancel="onCancel">
      <p>{{ resultInfo.conclusion }}</p>
    </a-modal>
  </div>
</template>

<script>
import {
  getPhysicalExam,
  getPhysicalExam2,
  getPhysicalExamNo,
  getPhysicalExamNo2,
  getConclusion,
} from "@/api/report";
import { getMemberUser } from "@/api/medicalBooking";
import base from "@/assets/base/base.js";
export default {
  filters: {
    dateFilter(v) {
      if (v) {
        return v.split(".")[0];
      }
    },
  },
  data() {
    return {
      loading: false,
      visible: false,
      startDate: "",
      endDate: "",
      activedIndex: 0,
      actived: 1,
      tabs: [
        { key: 1, name: "体检报告" },
        { key: 2, name: "体检报告-新版" },
        { key: 3, name: "体格检查" },
      ],
      list: [],
      detail: "",
      userInfo: {},
      resultInfo: {},
      page: 1,
      isLoading: true,
    };
  },
  created() {
    this.userInfo =
      sessionStorage.getItem("userInfo") &&
      JSON.parse(sessionStorage.getItem("userInfo"));
    this.getMemberUserInfo();
  },
  methods: {
    tabChange(e) {
      this.list = [];
      this.getList();
    },
    onOK() {
      this.visible = false;
    },
    onCancel() {
      this.visible = false;
    },
    //查看体检结论
    async viewResult(detail) {
      const { code, data } = await getConclusion({
        physicalExamNo: detail.physicalExamNo,
      });
      if (code == 200) {
        if (data) {
          this.visible = true;
          this.resultInfo = data;
        } else {
          this.$confirm({
            title: "提示",
            content: "暂无体检结论",
            onOk() {},
            onCancel() {},
          });
        }
      }
    },
    //查看报告
    onViewReport(item) {
      //体格检查：直接查看pdf报告
      if (this.actived == 3) {
        if (item.tjbUrl) {
          window.open(item.tjbUrl, "_blank");
        } else {
          this.$message.error("暂无报告pdf");
        }
        return;
      }
      sessionStorage.setItem("i", item.physicalExamNo);
      sessionStorage.setItem("v", this.actived);
      let path = location.origin + location.pathname;
      location.href = path + "report.html?t=" + new Date().getTime();
    },
    //获取名单信息
    async getMemberUserInfo() {
      //个人信息
      let params = {
        ...this.userInfo,
        age: this.userInfo.birthday ? base.sumAge(this.userInfo.birthday) : 0,
        idCard:
          this.userInfo.certificateType === "0"
            ? this.userInfo.idCard
            : this.userInfo.passport,
        patientName: this.userInfo.userName,
        phoneNumber: this.userInfo.phone,
      };
      const { code, data } = await getMemberUser(params);
      if (code == 200) {
        if (data) {
          this.userInfo1 = data;
        } else {
          this.userInfo1 = {};
        }
        this.getList();
      }
    },
    onChange(date, dateString) {
      this.startDate = dateString[0] || "";
      this.endDate = dateString[1] || "";
      this.list = [];
      this.getList();
    },
    onDown(detail) {
      let dom = document.createElement("a");
      dom.href = "./report.html";
      sessionStorage.setItem("v", this.actived);
      sessionStorage.setItem("i", detail.physicalExamNo);
      dom.target = "_self";
      document.body.appendChild(dom);
      // 点击下载
      dom.click();
      document.body.removeChild(dom);
    },
    /**获取体检报告 */
    async getList() {

      const params = {
        name: this.actived == 1 ? this.userInfo1.name : "",
        status: this.actived == 1 ? "" : "9",
        idCardNo: this.userInfo1.idNumber,
        physicalExamNo: "",
        startDate: this.startDate,
        endDate: this.endDate,
        pageNum: 1,
        pageSize: 9999,
        sftjb: this.actived == 3 ? "1" : "0", //0->体检报告 1->体格检查
      };
      this.loading = true;
      //体格检查使用新版接口
      let { data, code } =
        this.actived == 2 || this.actived == 3
          ? await getPhysicalExam2(params)
          : await getPhysicalExam(params);
      this.loading = false;
      if (code == 200) {
        //临时隐藏
        this.list = data.filter((e) => e.physicalExamNo != "180702159");
        if (data && data.length > 0) {
          if (this.actived == 1) {
            if (this.$route.query.physicalExamNo) {
              this.activedIndex = data.findIndex(
                (item) =>
                  item.physicalExamNo == this.$route.query.physicalExamNo
              );
              this.getNoDetail();
            } else {
              this.getNoDetail(data[0]);
            }
          } else {
            this.activedIndex = -1;
          }
        }
      }
    },

    onDetail(data, activedIndex) {
      this.$router.replace({
        path: "/medicalReport",
        query: { physicalExamNo: data.physicalExamNo },
      });
      this.activedIndex = activedIndex;
      this.getNoDetail(data);
    },

    /**获取详情 */
    async getNoDetail(params) {
      let physicalExamNo = "";
      if (this.$route.query.physicalExamNo) {
        physicalExamNo = this.$route.query.physicalExamNo; //体检编号
      } else {
        physicalExamNo = params && params.physicalExamNo; //体检编号
      }
      //加密
      let reqData={
        physicalExamNo:base.encryptAES(physicalExamNo)
      }
      const { data, code } =
        this.actived == 2
          ? await getPhysicalExamNo2(reqData)
          : await getPhysicalExamNo(reqData);
      if (code == 200) {
        this.detail = data;
        // if (this.actived == 2) {
        //   if (data.picList.length > 0) {
        //     location.href = data.picList[0].url;
        //   } else {
        //     this.$message.error("暂无报告pdf");
        //   }
        // } else {
        //   this.detail = data;
        // }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.h5-style {
  font-weight: 600;
}
.down {
  position: absolute;
  top: 10px;
  right: 20px;
}
.result-btn {
  position: absolute;
  top: 10px;
  right: 100px;
}
.range-picker {
  padding: 0 20px 10px;
}
.container {
  .tab-content {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;

    .list,
    .detail {
      position: relative;
      border: 1px solid #e8e8e8;
      padding: 16px;
      height: 800px;
      overflow-y: auto;
    }

    .scroll {
      flex: 1;
      height: 680px;

      .list {
        background: inherit;
        background-color: rgba(255, 255, 255, 1);

        .list-item {
          display: flex;
          // margin-bottom: 16px;
          border-bottom: 1px solid #f8f8f8;
          cursor: pointer;
          align-items: center;
          cursor: pointer;

          img {
            width: 40px;
            height: 40px;
            margin: 12px;
          }

          .list-pro-name {
            .item-name,
            .item-time {
              margin: 4px 0;
            }
          }
        }
      }
    }

    .detail {
      flex: 2;
      background: inherit;
      background-color: rgba(255, 255, 255, 1);
    }
  }
}

/deep/.ant-tabs-tab {
  font-size: 20px;
}

.actived {
  // border-bottom: 2px solid #3F86FF !important;
  // background-color: #ffffff !important;
  // background: linear-gradient(90deg, #82b0ff 0%, #3e83f9 100%);
  background-color: rgba($color: #3e83f9, $alpha: 0.1);
  border-bottom: 1px solid #3e83f9 !important;
}
.header {
  margin-top: 20px;
}
.btn {
  margin-left: 20px;
}
.loading-x {
  text-align: center;
}
</style>
